import { render } from "./ChatbotHeader.vue?vue&type=template&id=66783f7e&scoped=true"
import script from "./ChatbotHeader.vue?vue&type=script&lang=js"
export * from "./ChatbotHeader.vue?vue&type=script&lang=js"

import "./ChatbotHeader.vue?vue&type=style&index=0&id=66783f7e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66783f7e"]])

export default __exports__